interface HowItWorksCardProps {
	icon: string;
	step: string;
	title: string;
	description: string;
	imgWidth?: number;
	imgHeight?: number;
}

export default function HowItWorksCard({
	icon,
	step,
	title,
	description,
	imgWidth = 100,
	imgHeight = 100,
}: HowItWorksCardProps) {
	return (
		<div className="w-full max-w-[452px] md:max-w-[380px] lg-max-w-[452px] h-auto bg-white rounded-2xl p-8 shadow-sm flex flex-col items-center gap-6">
			<img
				alt={`Icon for ${title}`}
				src={icon}
				style={{ width: `${imgWidth}px`, height: `${imgHeight}px` }}
			/>

			<div className="flex flex-col items-center gap-4 text-center">
				<div className="rounded-full bg-gray-100 px-2.5 py-1 text-sm border border-primary-gray-lightest font-semibold font-urbanist">
					{step}
				</div>

				<div className="flex flex-col items-center gap-2 text-center">
					<p className="text-[20px] font-semibold leading-[140%] font-urbanist">{title}</p>
					<p className="text-[16px] font-normal leading-[150%] font-urbanist text-[#626373]">
						{description}
					</p>
				</div>
			</div>
		</div>
	);
}
